const getLibraryName = (): string => PACKAGE;
const getLibraryVersion = (): string => VERSION;

export { getLibraryName, getLibraryVersion };
